import { useSWRInfinite } from 'swr';
import { useTranslate } from '@tolgee/react';
import { NewsListItemFragment } from '@amf/shared/types/graphql';
import NewsListItem from '@amf/shared/components/news/NewsListItem';
import Button from '@amf/shared/components/button/Button';

export const LIMIT = 20;
const API_PATH = '/api/news';

const getApiPath = (pageIndex: number, prePageData: NewsListItemFragment[] | null) => {
  const params = new URLSearchParams({ offset: `${pageIndex}` });

  if (prePageData === null || pageIndex === 0) return `${API_PATH}?${params.toString()}`;
  if (prePageData.length < LIMIT) return null;

  return `${API_PATH}?${params.toString()}`;
};

type Props = {
  news: NewsListItemFragment[];
  prefixes: { newsList: string };
  contentClassName?: string;
  titleClassName?: string;
  timeClassName?: string;
  perexClassName?: string;
};

function NewsList({ news: initialData, prefixes, ...props }: Props) {
  const { t } = useTranslate();
  const { data, error, size, setSize } = useSWRInfinite<NewsListItemFragment[]>(getApiPath, {
    initialData: [initialData],
  });

  const loading = !data && !error;
  const news: NewsListItemFragment[] = data ? ([] as NewsListItemFragment[]).concat(...data) : [];

  function loadMore() {
    if (!news || data === undefined) {
      return null;
    }

    if (size > data.length) {
      return (
        <Button type='button' variant='dark-outline' disabled>
          {t('team.matches.loading')}
        </Button>
      );
    }

    if (LIMIT * size > news.length) {
      return null;
    }

    return (
      <Button type='button' variant='dark-outline' onClick={() => setSize(size + 1)}>
        {t('team.matches.more')}
      </Button>
    );
  }

  if (!news && !loading) {
    return null;
  }

  return (
    <div>
      {news.map(item => (
        <NewsListItem key={item.id} news={item} prefix={prefixes.newsList} {...props} />
      ))}
      <div className='TeamMatches__pagination'>{loadMore()}</div>
    </div>
  );
}

export default NewsList;
